import React from "react";
import Thumbnail from "./components/Thumbnail";
import ThumbnailDescriptiveBox from "./components/ThumbnailDescriptiveBox";
import { DayUseServiceIcons } from "../../../../../assets/SVGIcons";

const DayUseDesktopNav = ({
  setView,
  selections,
  view,
  isCollapsed,
  setIsCollapsed,
}) => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: "45px",
        marginTop: "60px",
        padding: "16px",
      }}
    >
      <div
        style={{
          display: "flex",
          position: "relative",
          justifyContent: isCollapsed ? "center" : "start",
        }}
        onClick={() => setView({ type: "show-hotels-details" })}
      >
        <Thumbnail
          size={{
            width: "104px",
            height: "104px",
          }}
          icon={DayUseServiceIcons.TrailSign(48, "white")}
          active
          background={
            ["show-hotel-details", "show-hotels-details"].includes(view)
              ? "#537C8B"
              : "#699DB0"
          }
          thumbnailNewStyles={{ zIndex: 2 }}
        />
        {!isCollapsed && (
          <ThumbnailDescriptiveBox
            title={"Locations"}
            desciption={"Learn about our locations"}
            isActive={["show-hotel-details", "show-hotels-details"].includes(
              view
            )}
          />
        )}
      </div>

      <div
        style={{
          display: "flex",
          position: "relative",
          justifyContent: isCollapsed ? "center" : "start",
        }}
        onClick={() => setView({ type: "show-activities" })}
      >
        <Thumbnail
          size={{
            width: "104px",
            height: "104px",
          }}
          icon={DayUseServiceIcons.Recipe(48, "white")}
          active
          background={
            ["show-activities"].includes(view) ? "#537C8B" : "#699DB0"
          }
          thumbnailNewStyles={{ zIndex: 2 }}
        />
        {!isCollapsed && (
          <ThumbnailDescriptiveBox
            title={"Experiences"}
            desciption={"View available experiences"}
            isActive={["show-activities"].includes(view)}
          />
        )}
      </div>

      <div
        style={{
          display: "flex",
          position: "relative",
          justifyContent: isCollapsed ? "center" : "start",
        }}
        onClick={() => setView({ type: "show-basket-details" })}
      >
        <Thumbnail
          size={{
            width: "104px",
            height: "104px",
            position: "relative",
          }}
          icon={DayUseServiceIcons.Basket(48, "white")}
          active
          enableBlueprint={selections.length > 0}
          blueprintContent={selections.length}
          background={
            [
              "show-basket-details",
              "day-use-confirmation-screen",
              "registration-view-preconfirm-view",
              "registration-view-add-card",
              "registration-view-form",
            ].includes(view)
              ? "#537C8B"
              : "#699DB0"
          }
          thumbnailNewStyles={{ zIndex: 2 }}
        />
        {!isCollapsed && (
          <ThumbnailDescriptiveBox
            title={"Basket"}
            desciption={"Confirm your reservations"}
            isActive={[
              "show-basket-details",
              "day-use-confirmation-screen",
              "registration-view-preconfirm-view",
              "registration-view-add-card",
              "registration-view-form",
            ].includes(view)}
          />
        )}
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "end",
          alignItems: "end",
          height: "85px",
        }}
      >
        <div
          style={{ display: "flex", alignItems: "center", gap: "5px", cursor: "pointer" }}
          onClick={() => setIsCollapsed(!isCollapsed)}
        >
          {!isCollapsed && (
            <img
              style={{ width: "25px", height: "25px" }}
              src={"/img/day_use_icons/leftArrow.svg"}
              alt="no img"
            />
          )}
          <p
            style={{
              fontWeigth: "bold",
              textDecoration: "underline",
              fontSize: "18px",
              color: "#699DB0",
            }}
          >
            {!isCollapsed ? "Collapse" : "Expand"}
          </p>
          {isCollapsed && (
            <img
              style={{ width: "25px", height: "25px" }}
              src={"/img/day_use_icons/rightArrow.svg"}
              alt="no img"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default DayUseDesktopNav;

